<section class="rounded-lg border border-greyscale-200 bg-white p-4">
  <div class="mb-4 flex items-start gap-3">
    <div class="shrink-0 rounded-full bg-primary-200 p-2 text-primary-500">
      <lucide-angular [img]="Sparkles" class="h-4 w-4" />
    </div>
    <div>
      <h4 class="text-heading-4 text-primary-900">
        {{ "objectives.reductionActionsTitle" | transloco }}
      </h4>
      <p class="mt-0.5 text-paragraph-s-reg text-greyscale-600">
        {{ "objectives.reductionActionsSubtitle" | transloco }}
      </p>
    </div>
  </div>

  @if (catalogue().length === 0) {
    <p class="text-paragraph-s-reg text-greyscale-500">
      {{ "objectives.reductionActionsEmpty" | transloco }}
    </p>
  } @else {
    <ul class="space-y-2">
      @for (action of catalogue(); track action.code) {
        <li
          class="flex items-start gap-3 rounded-lg border px-3 py-3 transition-colors"
          [class.border-primary-200]="isSelected(action.code)"
          [class.bg-primary-50]="isSelected(action.code)"
          [class.border-greyscale-200]="!isSelected(action.code)"
          [class.bg-greyscale-50]="!isSelected(action.code)"
        >
          <p-checkbox
            [binary]="true"
            [ngModel]="isSelected(action.code)"
            [disabled]="isSaving()"
            (onChange)="toggle(action.code)"
            [inputId]="'reduction-action-' + action.code"
          />
          <div class="min-w-0 flex-1">
            <label
              [for]="'reduction-action-' + action.code"
              class="block cursor-pointer"
            >
              <span class="text-paragraph-s-semi block text-primary-900">
                {{
                  "objectives.reductionActions." + action.code + ".title"
                    | transloco
                }}
              </span>
              <span
                class="mt-0.5 block text-paragraph-xs-reg leading-snug text-greyscale-600"
              >
                {{ descriptionKey(action) | transloco: thresholdsFor(action) }}
              </span>
            </label>
            @if (
              action.code === "transport_alternative" &&
                transportAlternativeOptions();
              as options
            ) {
              <button
                type="button"
                class="text-paragraph-xs-semi mt-2 inline-flex items-center gap-1 text-primary-500 hover:text-primary-700"
                [attr.aria-expanded]="showTransportAlternativeOptions()"
                (click)="
                  showTransportAlternativeOptions.set(
                    !showTransportAlternativeOptions()
                  )
                "
              >
                <lucide-angular [img]="Settings2" class="h-3.5 w-3.5" />
                {{
                  "objectives.transportAlternativeOptions.toggle" | transloco
                }}
              </button>
              @if (showTransportAlternativeOptions()) {
                <div class="mt-2">
                  <app-transport-alternative-options
                    [options]="options"
                    (saved)="transportAlternativeOptions.set($event)"
                  />
                </div>
              }
            }
          </div>
        </li>
      }
    </ul>
  }
</section>
